import React from "react";
import { Separator, Text } from "@showitinc/showit-wc";
import SubdomainNameUpdateForm from "../../../components/domainmanager/SubdomainNameUpdateForm";
import SiteSettingsActions from "../../../actions/SiteSettingsActions";
import { VIEW_DOMAIN } from "../../../stores/SiteSettingsStore";

const AddSubDomainView = ({ siteSettings }) => {
  const addSubdomainForm = siteSettings.get("addSubdomainForm");
  const isSaving = addSubdomainForm.get("saving");
  const primaryDomain = addSubdomainForm.get("primaryDomain");
  const error = addSubdomainForm.get("error");

  const _cancelSubdomainAdd = () => {
    SiteSettingsActions.changeView(VIEW_DOMAIN);
  };

  const _addNewSubdomain = (data) => {
    SiteSettingsActions.addSubdomain(data);
  };

  return (
    <div
      className="view-centered"
      style={{
        flexDirection: "column",
        position: "relative",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        background: "var(--background-base-primary)",
      }}
    >
      <div style={{ width: "80%", height: "60%" }}>
        <div className="view-centered" style={{ flexDirection: "column" }}>
          <Text variant="heading-1">Add +Site Domain</Text>
          <Separator />
          <SubdomainNameUpdateForm
            primaryDomain={primaryDomain && primaryDomain.toJS()}
            onCancel={_cancelSubdomainAdd}
            onNameUpdate={_addNewSubdomain}
            submitting={isSaving}
            error={error && error.toJS()}
          />
        </div>
      </div>
    </div>
  );
};

export default AddSubDomainView;
